import { gql } from "@apollo/client";

export const getLensStatus = gql`
    query getLensStatus($lensId: ID!) {
        getLens(input: { lensId: $lensId }) {
            lens {
                id
                status
            }
        }
    }
`;
